import React from 'react';
import styles from '../styles/WarningPanel.module.css';

import IconContainer from '../Components/IconContainer';
import { ReactComponent as XIcon } from '../icons/x-close.svg';

export default function DismissibleBanner({ id, headline = 'Объявление', text }) {
    const storageKey = `dismissedBanner_${id}`;

    const [isVisible, setIsVisible] = React.useState(() => {
        return localStorage.getItem(storageKey) !== '1';
    });

    const handleClose = () => {
        localStorage.setItem(storageKey, '1');
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <div className={`${styles.panel}`} style={{flexDirection: 'column'}}>
                <div style={{width: '100%', display: 'flex', justifyContent: 'space-between', alignContent: 'center'}}>
                    <span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 256 256"><path d="M116,132V80a12,12,0,0,1,24,0v52a12,12,0,0,1-24,0ZM236,91.55v72.9a19.86,19.86,0,0,1-5.86,14.14l-51.55,51.55A19.85,19.85,0,0,1,164.45,236H91.55a19.85,19.85,0,0,1-14.14-5.86L25.86,178.59A19.86,19.86,0,0,1,20,164.45V91.55a19.86,19.86,0,0,1,5.86-14.14L77.41,25.86A19.85,19.85,0,0,1,91.55,20h72.9a19.85,19.85,0,0,1,14.14,5.86l51.55,51.55A19.86,19.86,0,0,1,236,91.55Zm-24,1.66L162.79,44H93.21L44,93.21v69.58L93.21,212h69.58L212,162.79ZM128,156a16,16,0,1,0,16,16A16,16,0,0,0,128,156Z"></path></svg>
                        <h3 style={{fontWeight: '500'}}>{headline}</h3>
                    </span>
                    <IconContainer Icon={XIcon} onClick={handleClose} size='17' color='black' className='' />
                </div>
                {text}
        </div>
    );
}
